import { z } from 'zod';
import { ufSchema } from './cidades.ts';
import { regimeTributarioSchema, tipoPessoaSchema, uuidSchema } from './comum.ts';

/**
 * Consultas públicas de apoio ao cadastro: CNPJ e CEP.
 *
 * O resultado é **sugestão**, não verdade: preenche o formulário e o usuário
 * confere antes de salvar. A base da Receita tem registro desatualizado, e o
 * endereço do CEP nem sempre é o do estabelecimento.
 *
 * Por isso nenhum campo aqui é obrigatório além da identificação — o serviço
 * externo pode devolver menos do que se espera, e a tela precisa preencher o
 * que veio em vez de recusar a resposta inteira.
 */

export const enderecoConsultadoSchema = z.object({
  cep: z.string().nullable(),
  logradouro: z.string().nullable(),
  numero: z.string().nullable(),
  complemento: z.string().nullable(),
  bairro: z.string().nullable(),
  uf: ufSchema.nullable(),
  cidadeNome: z.string().nullable(),
  /**
   * Município já resolvido no cadastro local, quando encontrado.
   *
   * Vem preenchido para a tela não precisar de uma segunda busca por nome —
   * que erraria em "Bom Jesus", nome de município em onze estados.
   */
  cidadeId: uuidSchema.nullable(),
});

export type EnderecoConsultado = z.infer<typeof enderecoConsultadoSchema>;

export const consultaCnpjSchema = z.object({
  cnpj: z.string(),
  razaoSocial: z.string(),
  nomeFantasia: z.string().nullable(),
  /** `Ativa`, `Baixada`, `Suspensa`… conforme a Receita. */
  situacaoCadastral: z.string().nullable(),
  /** Deduzido do enquadramento; o usuário confirma na tela. */
  regimeTributario: regimeTributarioSchema.nullable(),
  tipo: tipoPessoaSchema,
  endereco: enderecoConsultadoSchema,
});

export type ConsultaCnpj = z.infer<typeof consultaCnpjSchema>;

export const consultaCepSchema = enderecoConsultadoSchema;
export type ConsultaCep = z.infer<typeof consultaCepSchema>;

/** Códigos de erro das consultas externas. */
export const CODIGOS_CONSULTA = {
  NAO_ENCONTRADO: 'consulta_nao_encontrada',
  INDISPONIVEL: 'consulta_indisponivel',
  LIMITE_EXCEDIDO: 'consulta_limite_excedido',
} as const;
